// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"34b5e40a8b06ea78864a","6980":"44c062fae9e412e59333"}[chunkId] + ".js";
};